module.exports = __webpack_public_path__ + "img/Tessellate31.4537b584.jpg";